import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { LanguageService } from '../../services';

@Component({
  selector: 'about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  english: boolean;

  // *** Content *** //

  title: string;
  slogan: string;
  imgurl: string = '../../assets/backgrounds/iceberg.jpg'

  whoweare: string;
  ourteam: string;
  description: string;

  // ***************************** //

  constructor(private titleService: Title, private languageService: LanguageService) { }

  ngOnInit() {
    this.titleService.setTitle('eyeSnap - About');
    this.initContent();
  }

  onLanguage() {
    this.initContent();
  }

  // *** Content *** //

  initContent() {
    this.languageService.getLanguage()
      .subscribe(english => this.english = english);
    if (this.english) {
      this.title = 'About';
      this.slogan = 'Learn about us';
      this.whoweare = 'Who we are';
      this.ourteam = 'Our team';
      this.description = '';
    } else {
      this.title = 'A propos';
      this.slogan = 'A propos d\'eyeSnap';
      this.whoweare = 'Qui sommes nous ?';
      this.ourteam = 'Notre équipe';
      this.description = 'eyeSnap est une société spécialisée dans les technologies de reconnaissance visuelle. Depuis 8 ans, nous livrons avec succès des projets dont la matière première est l\'image, principalement pour les marchés de la sécurité, de l\'industrie et de l\'e-commerce. Notre équipe est composée d\'une majorité de jeunes ingénieurs réunissant des compétences en Intelligence Artificielle/Deep learning, en vision par ordinateur, en développements mobile, front-end et back-end.';
    }
  }

}
